import React from "react";
import "./Testimonials.css";
const jobTestimonials = [
  {
    name: "Siddharth Jain",
    role: "Frontend Developer at Zoho",
    story:
      "Building real-world apps with React during the course gave me the confidence to clear the Zoho frontend rounds. The project portfolio played a big role.",
  },
  {
    name: "Meera Nair",
    role: "Data Analyst at Infosys",
    story:
      "The Python and ML modules were structured so well that I could confidently handle case studies during the Infosys interview process.",
  },
  {
    name: "Pratik Deshmukh",
    role: "Software Engineer at TCS",
    story:
      "Skillzverse’s Java training and mock interviews were crucial in helping me land the job at TCS. The code review sessions were a game-changer.",
  },
  {
    name: "Ravi Kumar",
    role: "Backend Engineer at HCL",
    story:
      "The backend and system design sections helped me handle real technical interview scenarios. Java and REST API content was spot on.",
  },
];


const JobSuccessTestimonials = () => {
  return (
    <div className="testimonial-section">
      <h2 className="testimonial-heading">Success Stories</h2>
      <div className="testimonial-slider">
        <div className="testimonial-track">
        <div className="testimonial-track">
  {[...jobTestimonials, ...jobTestimonials].map((item, index) => (
    <div className="testimonial-card" key={index}>
      <h3>{item.name}</h3>
      <p className="testimonial-course">{item.course || item.role}</p>
      <p>"{item.review || item.story}"</p>
    </div>
  ))}
</div>

        </div>
      </div>
    </div>
  );
};

export default JobSuccessTestimonials;
